import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { InitialsPipe } from 'libs/shared/util-common/src/lib/pipes/initials.pipe';
import { IconDirective, TooltipDirective, ButtonDirective, AvatarComponent } from 'shared/ui-common';
import { NamePipe } from 'shared/util-common';

import { ConcurrencyService } from '../../concurrency.service';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-currently-edited-by',
  templateUrl: './currently-edited-by.component.html',
  styleUrls: ['./currently-edited-by.component.scss'],
  imports: [AvatarComponent, TranslocoPipe, TooltipDirective, NamePipe, IconDirective, MatIconModule, InitialsPipe, ButtonDirective],
})
export class CurrentlyEditedByComponent {
  protected concurrencyService = inject(ConcurrencyService);

  public reload = output<void>();

  protected currentlyEditingUsers = this.concurrencyService.currentlyEditingUsers;
  protected refreshGuidelineButtonEnabled = this.concurrencyService.refreshGuidelineButtonEnabled;
  protected currentlyEditedByAnotherUser = computed(() => this.concurrencyService.currentlyEditingUsers()?.length > 0);
}
